// extracted by mini-css-extract-plugin
module.exports = {"check":"check--2hJSd","check__label":"check__label--2_663","wrapper":"wrapper--1wKXw"};